<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    v-card-title.pa-0
    div.px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('adjustment').toLowerCase() }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('adjustment').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="onConfirm") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    leadPid() {
      return this.$route.params.pid
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    async onConfirm () {
      this.isLoading = true
      try {
        const endpoint = `/invoices/${this.leadPid}`
        const payload = { invoice_discount: 0 }
        const resp = await this.$axios.patch(`/invoices/${this.leadPid}`, payload)
        this.updateOldActivityLog(endpoint, payload, resp.data, 'PATCH', null)
        this.createActivityLog('delete_adjustment', 'Adjustment was removed')
        this.$emit('deleted')
        this.showDialog = false
        this.showMessage(['success', this.$t('success_message.update_successful')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateOldActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'invoice',
        activity: `Update invoice (#${response.rid})`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data).catch(() => {})
    },
    createActivityLog (tag, activity) {
      const payload = {
        company: this.company.id,
        app_model: 'form.lead',
        object_id: this.leadPid,
        tag,
        group: 'checkout',
        activity
      }
      this.$axios.post('/actions', payload).catch(() => {})
    }
  },
}
</script>

<style lang="scss" scoped>
</style>